import { useEffect, useState } from 'react';
import i18n from '../i18n';
import { normalizeLocale } from '../i18n/languages';

/**
 * Changes when UI locale changes — use as React `key` or in useEffect deps to refetch API-backed text.
 */
export function useLocaleKey() {
  const [key, setKey] = useState(() => normalizeLocale(i18n.resolvedLanguage || i18n.language));

  useEffect(() => {
    const onChange = (lng) => setKey(normalizeLocale(lng));
    i18n.on('languageChanged', onChange);
    return () => i18n.off('languageChanged', onChange);
  }, []);

  return key;
}
